import * as React from 'react';
export var RefContext = /*#__PURE__*/React.createContext({});